var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "botcode-page page"
  }, [_c('m-head'), _c('div', {
    staticClass: "botcode-main page-main"
  }, [_c('div', {
    staticClass: "botcode-bg",
    style: {
      background: `url(${require(`@images/botcode/botcode-bg.jpg`)}) center top/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "botcode__title"
  }, [_vm._v("Find the correct Botcode sequence")]), _c('div', {
    staticClass: "botcode-step"
  }, [_c('div', {
    staticClass: "botcode-step-main",
    class: this.gameBalance && this.gameBalance.amount <= 0 && 'err',
    on: {
      "click": _vm.onBuyAmount
    }
  }, [_vm.gameBalance ? _c('span', [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-moves.png'),
      "alt": ""
    }
  }), _vm._v(" Moves: "), !_vm.isMovesAnim ? [_vm._v(" " + _vm._s(_vm.fmt_pre(_vm.gameBalance.amount)) + " ")] : [_c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.gameBalance.amount)
    }
  })], _c('div', {
    staticClass: "stock-number",
    attrs: {
      "id": "stockNumberDiv"
    }
  })], 2) : _vm._e(), _c('div', {
    staticClass: "botcode-icon-add"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-add"
    }
  })], 1)])]), this.gameBalance ? _c('div', {
    staticClass: "botcode-time"
  }, [this.gameBalance.amount < this.gameBalance.recovery.count ? _c('span', [_c('i', [_vm._v(_vm._s(_vm.fmt_cjs(this.gameBalance.recovery.countdown)))]), _vm._v(" +" + _vm._s(this.gameBalance.recovery.count - this.gameBalance.amount) + " Moves")]) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "botcode-game"
  }, [_c('div', {
    staticClass: "botcode-game-main"
  }, [_c('div', {
    staticClass: "botcode-game-light"
  }), _c('div', {
    staticClass: "botcode-game-btns"
  }, [_c('span', [_c('div', {
    staticClass: "botcode-game-btn",
    on: {
      "click": () => _vm.popGameRuleShow = true
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-rule",
      "spin": _vm.isPayRestartLoading
    }
  }), _vm._v(" Rules")], 1)]), _c('span', [_vm.gameInfo && _vm.gameInfo.step > 0 ? _c('div', {
    staticClass: "botcode-game-btn",
    on: {
      "click": _vm.onRestart
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-refresh",
      "spin": _vm.isPayRestartLoading
    }
  }), _vm._v(" Restart")], 1) : _vm._e()])]), _c('div', {
    staticClass: "botcode-game__title",
    style: {
      background: `url(${require(`@images/botcode/game-title-bg.png`)}) center top/100% auto no-repeat`
    }
  }, [_c('span', [_vm._v("Puzzle " + _vm._s(_vm.gameInfo ? _vm.gameInfo.step + 1 : "--") + " ")])]), _c('div', {
    staticClass: "botcode-game-reward"
  }, [_c('div', {
    staticClass: "botcode-game-reward-main"
  }, [_c('div', {
    staticClass: "botcode-game-reward__title"
  }, [_vm._v("Rewards")]), _c('div', {
    staticClass: "botcode-game-reward-list"
  }, [_vm.gameInfo ? _vm._l(_vm.gameInfo.rewards, function (value, key, index) {
    return _c('div', {
      staticClass: "botcode-game-reward-item"
    }, [key == 'coin' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-hic.png`),
        "alt": ""
      }
    }) : key == 'ticket' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-pass.png`),
        "alt": ""
      }
    }) : key == 'giftshard' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-giftshare.png`),
        "alt": ""
      }
    }) : _vm._e(), _c('span', [_vm._v("+"), !_vm.isBotcodeGameInfoShow ? [_vm._v(_vm._s(_vm.fmt_pre(value)))] : _c('m-count-up', {
      attrs: {
        "endVal": Number(value)
      }
    })], 2)]);
  }) : _vm._e()], 2)])]), _c('div', {
    staticClass: "botcode-game-body"
  }, [_c('div', {
    staticClass: "botcode-game-box"
  }, [_c('transition', {
    attrs: {
      "name": "botcodeGameInfo"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isBotcodeGameInfoShow,
      expression: "isBotcodeGameInfoShow"
    }],
    staticClass: "botcode-game__info"
  }, [_vm._v("Puzzle " + _vm._s(this.gameInfo ? this.gameInfo.step + 1 : "--") + " Start")])]), _vm.gameInfo ? _c('div', {
    staticClass: "botcode-game-list",
    class: _vm.gameInfo.logs.length <= 2 && 'column'
  }, [_c('div', {
    staticClass: "botcode-game-scroll"
  }, [_vm._l(_vm.gameInfo.logs.slice(-2), function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "botcode-game-item",
      class: _vm.gameInfo.logs.slice(-2).length - 1 == index && _vm.isErrorAnim && 'error'
    }, [item.isAnim ? [_c('transition-group', {
      staticClass: "botcode-game-lis",
      class: [_vm.gameInfo && _vm.gameInfo.size <= 3 && 'three', _vm.gameInfo && _vm.gameInfo.size == 4 && 'four', _vm.gameInfo && _vm.gameInfo.size == 5 && 'five', _vm.gameInfo && _vm.gameInfo.size == 6 && 'six', _vm.gameInfo && _vm.gameInfo.size >= 7 && 'seven'],
      attrs: {
        "appear": "",
        "tag": "div"
      },
      on: {
        "before-enter": _vm.beforeEnter,
        "enter": _vm.enterGameItem
      }
    }, _vm._l(item.results, function (itm, idx) {
      return _c('div', {
        key: `mp${index}-${idx}`,
        staticClass: "botcode-game-itm",
        attrs: {
          "data-index": idx <= 50 ? idx + 1 : 0
        }
      }, [!itm.correct ? _c('img', {
        staticClass: "bg",
        attrs: {
          "src": require(`@images/botcode/game-item-bg.png`),
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "bgok",
        attrs: {
          "src": require(`@images/botcode/game-item-ok-bg.png`),
          "alt": ""
        }
      }), !itm.correct ? _c('img', {
        staticClass: "fail",
        attrs: {
          "src": _vm.gameOption.filter(it => it.id == itm.id)[0].fail_image,
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "icon",
        attrs: {
          "src": _vm.gameOption.filter(it => it.id == itm.id)[0].image,
          "alt": ""
        }
      })]);
    }), 0)] : _vm._e()], 2);
  }), _c('div', {
    staticClass: "botcode-game-item"
  }, [_c('transition-group', {
    staticClass: "botcode-game-lis",
    class: [_vm.gameInfo && _vm.gameInfo.size <= 3 && 'three', _vm.gameInfo && _vm.gameInfo.size == 4 && 'four', _vm.gameInfo && _vm.gameInfo.size == 5 && 'five', _vm.gameInfo && _vm.gameInfo.size == 6 && 'six', _vm.gameInfo && _vm.gameInfo.size >= 7 && 'seven'],
    attrs: {
      "appear": "",
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterGameItem
    }
  }, _vm._l(_vm.selectOption, function (item, index) {
    return _c('div', {
      key: `mp${index}`,
      staticClass: "botcode-game-itm",
      attrs: {
        "data-index": index <= 50 ? index + 1 : 0
      },
      on: {
        "click": function ($event) {
          !_vm.isGameCheckLoading && _vm.onSelect(item, index, 0);
        }
      }
    }, [!item && _vm.rowIndex == index ? _c('img', {
      staticClass: "select",
      attrs: {
        "src": require(`@images/botcode/game-item-select-bg.png`),
        "alt": ""
      }
    }) : !item ? [_c('img', {
      staticClass: "bg",
      attrs: {
        "src": require(`@images/botcode/game-item-bg.png`),
        "alt": ""
      }
    }), _c('img', {
      staticClass: "bgIcon",
      attrs: {
        "src": require(`@images/botcode/game-item-bg-icon.png`),
        "alt": ""
      }
    })] : [_c('img', {
      staticClass: "bgok",
      attrs: {
        "src": require(`@images/botcode/game-item-ok-bg.png`),
        "alt": ""
      }
    }), _c('img', {
      staticClass: "icon",
      attrs: {
        "src": item.image,
        "alt": ""
      }
    })]], 2);
  }), 0), _vm.isGameCheckLoading ? _c('div', {
    staticClass: "botcode-game-loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]) : _vm._e()], 1)], 2)]) : _vm._e()], 1)])]), _c('div', {
    staticClass: "botcode-game-option"
  }, [_vm.isRefreshBtnOption ? _c('div', {
    staticClass: "botcode-game-option-main"
  }, _vm._l(_vm.gameOption, function (item, index) {
    return _c('span', {
      key: item.id,
      class: item.disable && 'disable'
    }, [_c('img', {
      staticClass: "xs",
      style: {
        opacity: item.disable ? 0 : 1,
        height: item.disable ? 0 : '100%'
      },
      attrs: {
        "src": item.image,
        "alt": ""
      },
      on: {
        "click": function ($event) {
          !_vm.isGameCheckLoading && _vm.onSelect(item, index, 1);
        }
      }
    }), _c('img', {
      style: {
        opacity: item.disable ? 1 : 0,
        height: item.disable ? '100%' : 0
      },
      attrs: {
        "src": item.image,
        "alt": ""
      },
      on: {
        "click": function ($event) {
          !_vm.isGameCheckLoading && _vm.onSelect(item, index, 1);
        }
      }
    })]);
  }), 0) : _vm._e()])]), _c('div', {
    staticClass: "botcode-banner",
    on: {
      "click": _vm.onSkipBanner
    }
  }, [_c('div', {
    staticClass: "botcode-banner-main",
    style: {
      background: `url(${require(`@images/botcode/game-banner.jpg`)}) center top/auto 100% no-repeat`
    }
  })]), _c('div', {
    staticClass: "botcode-rank"
  }, [_c('div', {
    staticClass: "botcode-rank__title"
  }, [_vm._v("Today Ranking")]), _c('div', {
    staticClass: "botcode-rank-list"
  }, _vm._l(_vm.rankList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "botcode-rank-item"
    }, [_c('div', {
      staticClass: "botcode-rank-item__img"
    }, [_c('m-head-img', {
      attrs: {
        "name": item,
        "bgColor": item.head_color
      }
    })], 1), _c('div', {
      staticClass: "botcode-rank-item-info"
    }, [_c('div', {
      staticClass: "botcode-rank-item__name"
    }, [_vm._v(_vm._s(item.firstname) + " " + _vm._s(item.lastname))]), _c('div', {
      staticClass: "botcode-rank-item__id"
    }, [_vm._v("#" + _vm._s(index + 1))])]), _c('div', {
      staticClass: "botcode-rank-item__step"
    }, [_vm._v("Puzzle " + _vm._s(_vm.fmt_pre(item.cipher_last_step + 1)))])]);
  }), 0)])]), _c('pop-prompt', {
    attrs: {
      "className": "popMoreSpinsClass",
      "show": _vm.popRestartShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popRestartShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-restart"
  }, [_c('div', {
    staticClass: "pop-restart__icon",
    style: {
      background: `url(${require(`@images/botcode/game-icon-restart.png`)}) center top/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "pop-restart__title"
  }, [_vm._v("Restart")]), _vm.gameInfo ? _c('div', {
    staticClass: "pop-restart__sub"
  }, [_vm._v(" After restarting, "), _vm.gameInfo.reset.countPerDay - _vm.gameBalance.amount <= 0 ? [_vm._v("you will return to "), _c('span', [_vm._v("Puzzle 1")])] : [_vm._v("you will receive "), _c('span', [_vm._v(_vm._s(_vm.gameInfo.reset.countPerDay - _vm.gameBalance.amount) + " Moves")]), _vm._v(" and return to "), _c('span', [_vm._v("Puzzle 1")])]], 2) : _vm._e(), _c('div', {
    staticClass: "popBotUpgrade-pay"
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-main"
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-item",
    class: _vm.payRestartType == 'Stars' && 'active',
    on: {
      "click": function ($event) {
        return _vm.onRestartSelectPay('Stars');
      }
    }
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-item-main"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-star.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.gameInfo ? _vm.fmt_pre(_vm.gameInfo.reset.cost.stars) : "--"))])])]), _c('div', {
    staticClass: "popBotUpgrade-pay-or"
  }, [_vm._v("OR")]), _c('div', {
    staticClass: "popBotUpgrade-pay-item",
    class: _vm.payRestartType == 'Ton' && 'active',
    on: {
      "click": function ($event) {
        return _vm.onRestartSelectPay('Ton');
      }
    }
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-item-main"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-ton.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.gameInfo ? _vm.fmt_pre(_vm.gameInfo.reset.cost.ton) : "--"))])])])]), _c('div', {
    staticClass: "popBotUpgrade-pay-btns"
  }, [_vm.isRestartPayCheck ? _c('div', {
    staticClass: "btn-go",
    on: {
      "click": _vm.onRestartPayCheck
    }
  }, [!_vm.isRestartPayCheckLoading ? [_vm._v("Check")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2) : _c('div', {
    staticClass: "btn-go",
    on: {
      "click": _vm.onPayRestart
    }
  }, [!_vm.isPayRestartLoading ? [_vm._v("Payment")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2)])])])]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "className": "popMoreSpinsClass",
      "show": _vm.popBuyAmountShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popBuyAmountShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-botcodestep"
  }, [_c('div', {
    staticClass: "pop-botcodestep__title"
  }, [_vm._v("Purchase moves")]), _c('div', {
    staticClass: "pop-botcodestep-list"
  }, [_c('transition-group', {
    staticClass: "pop-botcodestep-scroll",
    attrs: {
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, [_vm.buyAmountList && !_vm.buyAmountListLoading ? _vm._l(_vm.buyAmountList, function (item, index) {
    return _c('div', {
      key: `mp${index}`,
      staticClass: "pop-botcodestep-item",
      attrs: {
        "data-index": index <= 50 ? index + 1 : 0
      },
      on: {
        "click": function ($event) {
          return _vm.selectStorePrice(item, index);
        }
      }
    }, [_c('div', {
      staticClass: "pop-botcodestep-item-main"
    }, [_c('div', {
      staticClass: "pop-botcodestep-item__num"
    }, [_vm._v("+" + _vm._s(_vm.fmt_pre(item.count)) + " Moves")]), _c('div', {
      staticClass: "pop-botcodestep-item__sub"
    }), _c('div', {
      staticClass: "pop-botcodestep-item-info"
    }, [item.isLoading ? _c('div', {
      staticClass: "loading"
    }, [_c('div', {
      staticClass: "circleLoading"
    })]) : [_c('div', {
      staticClass: "pop-botcodestep-item-info__price"
    }, [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-star.png'),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(item.stars)))])])]], 2)])]);
  }) : _vm._e()], 2)], 1), _c('div', {
    staticClass: "pop-botcodestep-intro wow fadeInUp",
    attrs: {
      "data-wow-duration": "0.3s"
    }
  }, [_c('div', {
    staticClass: "pop-botcodestep-intro-main"
  }, [_c('div', {
    staticClass: "pop-botcodestep-intro-btn-record",
    on: {
      "click": _vm.onRecord
    }
  }, [_vm._v("Record "), _c('svg-icon', {
    attrs: {
      "name": "icon-arrow"
    }
  })], 1), _c('div', {
    staticClass: "pop-botcodestep-intro__title"
  }, [_vm._v("1 Friend = " + _vm._s(_vm.gameInfo ? _vm.fmt_pre(_vm.gameInfo.invitation.rewards.cipher) : "--") + " Moves")]), _c('div', {
    staticClass: "pop-botcodestep-intro__label"
  }, [_vm._v("Invite friends to participate")]), _c('div', {
    staticClass: "pop-botcodestep-intro-btns wow fadeInUp",
    attrs: {
      "data-wow-duration": "0.7s"
    }
  }, [_c('div', {
    staticClass: "btn-share",
    on: {
      "click": _vm.onShare
    }
  }, [_vm._v("Invite")]), _c('div', {
    staticClass: "btn-copy",
    on: {
      "click": _vm.onCopy
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-copy"
    }
  })], 1)])])])])]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "className": "popPayRecordClass",
      "show": _vm.popPayRecordShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popPayRecordShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-payrecord"
  }, [_c('div', {
    staticClass: "pop-payrecord__title"
  }, [_vm._v("Record")]), _vm.inviteRecordList && _vm.inviteRecordList.length > 0 ? _c('div', {
    ref: "poppayrecord",
    staticClass: "pop-payrecord-list"
  }, _vm._l(_vm.inviteRecordList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "pop-payrecord-item"
    }, [_c('div', {
      staticClass: "pop-payrecord-item__img"
    }, [_c('m-head-img', {
      attrs: {
        "name": item,
        "bgColor": item.head_color
      }
    })], 1), _c('div', {
      staticClass: "pop-payrecord-item__name"
    }, [_vm._v(_vm._s(item.firstname) + " " + _vm._s(item.lastname))]), _c('div', {
      staticClass: "pop-payrecord-item__step"
    }, [_vm._v("+" + _vm._s(_vm.fmt_pre(item.rewards.cipher)) + " Moves")])]);
  }), 0) : _c('div', {
    staticClass: "pop-payrecord-empty"
  }, [_vm._v("There's nothing here!")])])]), _c('pop-prompt', {
    attrs: {
      "className": "popMoreSpinsClass",
      "show": _vm.popSelectPaymentShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popSelectPaymentShow = $event;
      }
    }
  }, [_vm.rowStorePrice ? _c('div', {
    staticClass: "pop-selectPayment"
  }, [_c('div', {
    staticClass: "pop-selectPayment__title"
  }, [_vm._v("Select payment method")]), _c('div', {
    staticClass: "popBotUpgrade-pay"
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-main"
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-item",
    class: _vm.payType == 'Stars' && 'active',
    on: {
      "click": function ($event) {
        return _vm.onSelectPay('Stars');
      }
    }
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-item-main"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-star.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.rowStorePrice.stars)))])])]), _c('div', {
    staticClass: "popBotUpgrade-pay-or"
  }, [_vm._v("OR")]), _c('div', {
    staticClass: "popBotUpgrade-pay-item",
    class: _vm.payType == 'Ton' && 'active',
    on: {
      "click": function ($event) {
        return _vm.onSelectPay('Ton');
      }
    }
  }, [_c('div', {
    staticClass: "popBotUpgrade-pay-item-main"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-ton.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.rowStorePrice.ton)))])])])]), _c('div', {
    staticClass: "popBotUpgrade-pay-btns"
  }, [_vm.rowStorePrice.isBtnCheck ? _c('div', {
    staticClass: "btn-go",
    on: {
      "click": _vm.onPayAmountCheck
    }
  }, [!_vm.rowStorePrice.isBtnCheckLoading ? [_vm._v("Check")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2) : _c('div', {
    staticClass: "btn-go",
    on: {
      "click": _vm.onPayAmount
    }
  }, [!_vm.rowStorePrice.isLoading ? [_vm._v("Payment")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2)])])]) : _vm._e()]), _c('pop-prompt', {
    attrs: {
      "isClose": false,
      "show": _vm.popGameRewardShow,
      "content": "html",
      "title": "",
      "isBtnCancel": false,
      "isBtnConfirm": true,
      "confirmText": "Go head"
    },
    on: {
      "update:show": function ($event) {
        _vm.popGameRewardShow = $event;
      },
      "confirm": _vm.onPopGameRewardConfirm
    }
  }, [_c('div', {
    staticClass: "pop-gamereward"
  }, [_c('div', {
    staticClass: "pop-gamereward__icon",
    style: {
      background: `url(${require('@images/upgrade-box.png')}) center/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "pop-gamereward__title"
  }, [_vm._v("Congratulations")]), _vm.gameRewardInfo ? _c('div', {
    staticClass: "pop-gamereward-list"
  }, _vm._l(_vm.gameRewardInfo, function (value, key, index) {
    return _c('div', {
      staticClass: "pop-gamereward-item",
      class: key == 'giftshard' && 'giftshard'
    }, [key !== 'giftshard' ? [key == 'coin' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-hic.png`),
        "alt": ""
      }
    }) : key == 'ticket' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-pass.png`),
        "alt": ""
      }
    }) : key == 'giftshard' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-giftshare.png`),
        "alt": ""
      }
    }) : _vm._e(), _c('div', {
      staticClass: "pop-gamereward-item__label"
    }, [_vm._v("+"), _c('m-count-up', {
      attrs: {
        "endVal": Number(value)
      }
    })], 1)] : [_c('div', {
      staticClass: "pop-gamereward-item-giftshard"
    }, [_c('div', {
      staticClass: "pop-gamereward-item__title"
    }, [_vm._v("Shard Rewards(+" + _vm._s(index) + ")")]), _c('div', {
      staticClass: "pop-gamereward-item-scroll"
    }, _vm._l(value, function (val, ke, index) {
      return _c('div', {
        staticClass: "pop-gamereward-item-chip"
      }, [_c('div', {
        staticClass: "pop-gamereward-item-chip-icon",
        style: {
          background: `url(${val.thumb}) center top/auto 100% no-repeat`
        }
      }), _c('div', {
        staticClass: "pop-gamereward-item__name"
      }, [_vm._v(_vm._s(val.name))]), _c('div', {
        staticClass: "pop-gamereward-item__num"
      }, [_vm._v("+" + _vm._s(_vm.fmt_pre(val.amount)))])]);
    }), 0)])]], 2);
  }), 0) : _vm._e()])]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "show": _vm.popNoEnoughMovesShow,
      "className": "popNoEnoughMoveClass",
      "content": "html",
      "title": "",
      "width": "90%",
      "isBtnCancel": false,
      "isBtnConfirm": false
    },
    on: {
      "update:show": function ($event) {
        _vm.popNoEnoughMovesShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-noenoughmoves"
  }, [_c('div', {
    staticClass: "pop-noenoughmoves__title"
  }, [_c('span', [_vm._v("Puzzle " + _vm._s(_vm.gameInfo ? _vm.gameInfo.step + 1 : "--") + " ")]), _vm._v(" in progress ")]), _c('div', {
    staticClass: "pop-noenoughmoves-reward"
  }, [_c('div', {
    staticClass: "pop-noenoughmoves-reward-main"
  }, [_c('div', {
    staticClass: "pop-noenoughmoves-reward__title"
  }, [_vm._v("REWARDS")]), _vm.gameInfo ? _c('div', {
    staticClass: "pop-noenoughmoves-list"
  }, _vm._l(_vm.gameInfo.rewards, function (value, key, index) {
    return _c('div', {
      staticClass: "pop-noenoughmoves-item"
    }, [key == 'coin' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-hic.png`),
        "alt": ""
      }
    }) : key == 'ticket' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-pass.png`),
        "alt": ""
      }
    }) : key == 'giftshard' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-giftshare.png`),
        "alt": ""
      }
    }) : _vm._e(), _c('div', {
      staticClass: "pop-noenoughmoves-item__label"
    }, [_vm._v("+" + _vm._s(value))])]);
  }), 0) : _vm._e()])]), _c('div', {
    staticClass: "pop-noenoughmoves__sub"
  }, [_c('span', [_vm._v("How to get Moves")])]), _c('div', {
    staticClass: "pop-noenoughmoves-btns"
  }, [_c('div', {
    staticClass: "pop-noenoughmoves-btn",
    on: {
      "click": _vm.onBuyAmount
    }
  }, [_c('div', {
    staticClass: "pop-noenoughmoves-btn-main"
  }, [_c('div', {
    staticClass: "pop-noenoughmoves-btn__icon",
    style: {
      background: `url(${require(`@images/botcode/icon-invite.png`)}) center top/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "pop-noenoughmoves-btn__label"
  }, [_vm._v("Invite"), _c('br'), _vm._v("Friend")])])]), _c('div', {
    staticClass: "pop-noenoughmoves-btn",
    on: {
      "click": _vm.onBuyAmount
    }
  }, [_c('div', {
    staticClass: "pop-noenoughmoves-btn-main"
  }, [_c('div', {
    staticClass: "pop-noenoughmoves-btn__icon",
    style: {
      background: `url(${require(`@images/botcode/icon-buy.png`)}) center top/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "pop-noenoughmoves-btn__label"
  }, [_vm._v("Buy")])])]), _c('div', {
    directives: [{
      name: "tip",
      rawName: "v-tip.top.click",
      value: `Coming Soon`,
      expression: "`Coming Soon`",
      modifiers: {
        "top": true,
        "click": true
      }
    }],
    staticClass: "pop-noenoughmoves-btn"
  }, [_c('div', {
    staticClass: "pop-noenoughmoves-btn-main comingsoon"
  }, [_c('div', {
    staticClass: "pop-noenoughmoves-btn__icon",
    style: {
      background: `url(${require(`@images/botcode/icon-task.png`)}) center top/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "pop-noenoughmoves-btn__label"
  }, [_vm._v("Task")])])]), _c('div', {
    directives: [{
      name: "tip",
      rawName: "v-tip.top.click",
      value: `Coming Soon`,
      expression: "`Coming Soon`",
      modifiers: {
        "top": true,
        "click": true
      }
    }],
    staticClass: "pop-noenoughmoves-btn"
  }, [_c('div', {
    staticClass: "pop-noenoughmoves-btn-main comingsoon"
  }, [_c('div', {
    staticClass: "pop-noenoughmoves-btn__icon",
    style: {
      background: `url(${require(`@images/botcode/icon-lucky.png`)}) center top/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "pop-noenoughmoves-btn__label"
  }, [_vm._v("Lucky"), _c('br'), _vm._v("Wheel")])])])])])]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "show": _vm.popGameRuleShow,
      "className": "popNoEnoughMoveClass",
      "content": "html",
      "title": "",
      "width": "90%",
      "isBtnCancel": false,
      "isBtnConfirm": false
    },
    on: {
      "update:show": function ($event) {
        _vm.popGameRuleShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-gamerule"
  }, [_c('div', {
    staticClass: "pop-gamerule__title"
  }, [_vm._v("Rules")]), _c('div', {
    staticClass: "pop-gamerule-main"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Moves Rules")]), _c('p', {
    staticClass: "label"
  }, [_vm._v("Moves are required to challenge puzzle stages.")]), _c('p', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.gameBalance ? _vm.fmt_pre(_vm.gameBalance.recovery.count) : "--") + " free Moves are granted daily at 00:00 UTC; unused free Moves will be cleared.")]), _c('p', {
    staticClass: "label"
  }, [_vm._v("Extra Moves can be earned by (Extra Moves will not be cleared daily) :")]), _c('div', {
    staticClass: "pop-gamerule-btns"
  }, [_c('div', {
    staticClass: "pop-gamerule-btn",
    on: {
      "click": _vm.onBuyAmount
    }
  }, [_c('div', {
    staticClass: "pop-gamerule-btn-main"
  }, [_c('div', {
    staticClass: "pop-gamerule-btn__icon",
    style: {
      background: `url(${require(`@images/botcode/icon-invite.png`)}) center top/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "pop-gamerule-btn__label"
  }, [_vm._v("Invite"), _c('br'), _vm._v("Friend")])])]), _c('div', {
    staticClass: "pop-gamerule-btn",
    on: {
      "click": _vm.onBuyAmount
    }
  }, [_c('div', {
    staticClass: "pop-gamerule-btn-main"
  }, [_c('div', {
    staticClass: "pop-gamerule-btn__icon",
    style: {
      background: `url(${require(`@images/botcode/icon-buy.png`)}) center top/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "pop-gamerule-btn__label"
  }, [_vm._v("Buy")])])]), _c('div', {
    directives: [{
      name: "tip",
      rawName: "v-tip.top.click",
      value: `Coming Soon`,
      expression: "`Coming Soon`",
      modifiers: {
        "top": true,
        "click": true
      }
    }],
    staticClass: "pop-gamerule-btn"
  }, [_c('div', {
    staticClass: "pop-gamerule-btn-main comingsoon"
  }, [_c('div', {
    staticClass: "pop-gamerule-btn__icon",
    style: {
      background: `url(${require(`@images/botcode/icon-task.png`)}) center top/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "pop-gamerule-btn__label"
  }, [_vm._v("Task")])])]), _c('div', {
    directives: [{
      name: "tip",
      rawName: "v-tip.top.click",
      value: `Coming Soon`,
      expression: "`Coming Soon`",
      modifiers: {
        "top": true,
        "click": true
      }
    }],
    staticClass: "pop-gamerule-btn"
  }, [_c('div', {
    staticClass: "pop-gamerule-btn-main comingsoon"
  }, [_c('div', {
    staticClass: "pop-gamerule-btn__icon",
    style: {
      background: `url(${require(`@images/botcode/icon-lucky.png`)}) center top/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "pop-gamerule-btn__label"
  }, [_vm._v("Lucky"), _c('br'), _vm._v("Wheel")])])])]), _c('p', {
    staticClass: "title"
  }, [_vm._v("Stage Rules")]), _c('p', {
    staticClass: "label"
  }, [_vm._v("Stage progress resets daily at 00:00 UTC.")]), _c('p', {
    staticClass: "label"
  }, [_vm._v("Once opened, daily stages can be resumed anytime that day.")]), _c('p', {
    staticClass: "label"
  }, [_vm._v("Each completed stage grants a reward chest—clear more stages to earn more chests.")])])])]), _c('m-menu')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };